import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [logoAvailable, setLogoAvailable] = useState(true);
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="mc-movers-logo">
            {logoAvailable ? (
              <img
                src="/MCMovers Logo/logo.png"
                alt="MC Movers Logo"
                className="footer-logo-img"
                onError={() => setLogoAvailable(false)}
              />
            ) : (
              <div className="footer-logo-shield">
                <div className="footer-logo-mc">MC</div>
                <div className="footer-logo-movers">MOVERS</div>
                <div className="footer-logo-truck">🚛</div>
                <div className="footer-logo-tagline">My Community Movers</div>
              </div>
            )}
          </div>
          <p className="footer-tagline">Your trusted moving partner</p>
        </div>
        
        <div className="footer-info">
          <div className="contact-info">
            <h4>Contact Us</h4>
            <div className="contact-line">
              <a href="https://mc-movers.com" className="website-link" target="_blank" rel="noopener noreferrer">Visit Our Website</a>
              <span className="contact-separator"> | </span>
              <span className="phone-group">📞 <a href="tel:+18008072173" className="contact-link">(800) 807-2173</a></span>
              <span className="contact-separator"> | </span>
              <span className="email-group">✉️ <a href="mailto:support@mc-movers.com" className="contact-link">support@mc-movers.com</a></span>
            </div>
          </div>
          
          <div className="legal-links">
            <h4>Legal</h4>
            <a href="#terms">Terms & Conditions</a>
            <a href="#privacy">Privacy Policy</a>
            <a href="#insurance">Insurance Coverage</a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">© 2025 MC Movers. All rights reserved.</p>
          <Link to="/admin/login" className="staff-login-link">Staff Login</Link>
          <a
            href="/drivers/index.html"
            target="_blank"
            rel="noopener noreferrer"
            className="driver-portal-link"
          >
            Driver Portal
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
